import React from 'react'
import { F0Box, F0Icon, F0OneIcon, F0Text } from '@factorialco/f0-react'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import i18n from 'modules/core/lib/i18n'

type TicketAiInsightsProps = {
  aiSummary: string | null | undefined
  aiResolutionProposal: string | null | undefined
  enabled: boolean
}

export const TicketAiInsights: React.FC<TicketAiInsightsProps> = ({
  aiSummary,
  aiResolutionProposal,
  enabled,
}) => {
  if (!enabled || (!aiSummary && !aiResolutionProposal)) return null

  return (
    <div className="flex w-full flex-col rounded-lg bg-gradient-to-l from-[#A1ADE51F] via-[#E519431F] to-[#E556191F] p-[1px]">
      <F0Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="md"
        paddingX="lg"
        paddingY="xs"
      >
        <F0Icon icon={F0OneIcon} size="sm" />
        <F0Text variant="label" content={i18n.t('ticketing.inbox.ai.one_suggestion')} />
      </F0Box>
      <F0Box
        display="flex"
        flexDirection="column"
        borderRadius="xl"
        background="primary"
        paddingX="lg"
        paddingY="lg"
        gap="lg"
      >
        {aiSummary && (
          <F0Box display="flex" flexDirection="column" gap="md">
            <F0Text variant="label" content={i18n.t('ticketing.inbox.ai.summary_title')} />
            <RichTextDisplay
              format="markdown"
              content={aiSummary}
              className="text-md text-f1-foreground-secondary"
            />
          </F0Box>
        )}
        {aiSummary && aiResolutionProposal && <hr className="my-2 border-b-0 border-f1-border" />}
        {aiResolutionProposal && (
          <F0Box display="flex" flexDirection="column" gap="md">
            <F0Text
              variant="label"
              content={i18n.t('ticketing.inbox.ai.resolution_proposal_title')}
            />
            <RichTextDisplay
              format="markdown"
              content={aiResolutionProposal}
              className="text-md text-f1-foreground-secondary"
            />
          </F0Box>
        )}
      </F0Box>
    </div>
  )
}
